import { connect } from 'react-redux'
import Modal from './modal';

export default connect()(Modal);
